module.exports = __webpack_public_path__ + "img/supplySolutions1.cf4ede01.png";